import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({
    selector: "[mac-inp]",
})
export class MacInpDirective {
    constructor(public ref: ElementRef) {}

    static uppercaseValue(value: string) {
        const matches = (value || "").replace(/:/g, "").match(/([0-9a-fA-F]){1,2}/g) || [];
        return matches.join(":").toUpperCase();
    }

    @HostListener("focusout", ["$event"]) onBlur($event) {
        const newVal = MacInpDirective.uppercaseValue($event.target.value);
        $event.target.value = newVal;
        const evt = new Event("input");
        $event.target.dispatchEvent(evt);
    }
}
